import SortDirection from "types/sort-direction";

const compareModelsFn = <T>(a: T, b: T, sortBy: keyof T, sortDirection: SortDirection): number => {
  const valueA = a[sortBy] ?? "";
  const valueB = b[sortBy] ?? "";

  if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
  if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
  return 0;
};

export default compareModelsFn;
